import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import AddUserBox from "./add_user_box";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    relatedUsers: PropTypes.array.isRequired,
    messageGroupId: PropTypes.number.isRequired,
    messageGroupsUserIds: PropTypes.array.isRequired,
    loadMessageListFromServer: PropTypes.func,
    loadRelatedUsersFromServer: PropTypes.func,
  },
  getInitialState() {
    return {
      currentUserId: [],
      relatedUsers: [],
      userSearchResult: [],
    };
  },
  searchTunaGateUser: function() {
    var search_condition = this.search_condition.value;
    $.ajax({
      url: "/api/user/search_tunagate_user",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: { search_condition: search_condition },
      cache: false,
      success: function(data) {
        if (data != "0") {
          this.setState({
            userSearchResult: data,
          });
        }
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  handleAddUserToMessageGroup: function() {
    $.ajax({
      url: "/api/message/add_user_to_message_group",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        message_group_id: this.props.messageGroupId,
        user_id: this.state.userSearchResult.user.id,
      },
      cache: false,
      success: function(data) {
        if (data === "success") {
          this.props.loadMessageListFromServer();
          this.props.loadRelatedUsersFromServer();
          this.setState({
            userSearchResult: [],
          });
        }
      }.bind(this),
      error: function() {}.bind(this),
    });
  },  
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    var messageGroupId = this.props.messageGroupId;
    var messageGroupsUserIds = this.props.messageGroupsUserIds;
    var loadMessageListFromServer = this.props.loadMessageListFromServer;
    var loadRelatedUsersFromServer = this.props.loadRelatedUsersFromServer;
    var userSearchResult = "";
    if (this.state.userSearchResult.user) {
      userSearchResult = (
        <ul className="nav modal-main-menu mt-4">
          <li>
            <label>
              <img
                src={this.state.userSearchResult.user.avatar_thumb}
                style={{ width: "32px", height: "32px" }}
              />&nbsp;
              {this.fullname_disp(this.state.userSearchResult.user)}
              {this.state.userSearchResult.user.firstname}&nbsp;&nbsp;<a
                onClick={this.handleAddUserToMessageGroup}
              >
                <i className="fas fa-plus-circle" />
              </a>
            </label>
          </li>
        </ul>
      );
    }
    var addUserList = this.props.relatedUsers.map(function(user) {
      return (
        <AddUserBox
          relatedUser={user}
          messageGroupId={messageGroupId}
          messageGroupsUserIds={messageGroupsUserIds}
          loadMessageListFromServer={loadMessageListFromServer}
          loadRelatedUsersFromServer={loadRelatedUsersFromServer}
          key={user.id}
        />
      );
    });
    return (
      <div>
        <h4 className="mt20">メンバーを追加</h4>
        <section>
          <label className="input input-file">
            <div className="input-group u-file-attach-v1 g-brd-gray-light-v2">
              <input
                className="form-control form-control-md rounded-0"
                ref={(c) => {
                  this.search_condition = c;
                }}
                type="text"
                placeholder="つなげーとIDまたはメールアドレス"
              />
              <div className="input-group-btn">
                <div
                  className="btn btn-md btn-info rounded-0"
                  onClick={this.searchTunaGateUser}
                >
                  <i className="fas fa-search" aria-hidden="true" />
                </div>
              </div>
            </div>
          </label>
          {userSearchResult}
        </section>

        <ul className="search-result-tunagate-user nav modal-main-menu mt10" />
        <h5 className="mt20">メンバー候補</h5>
        <ul className="nav modal-main-menu">{addUserList}</ul>
      </div>
    );
  },
});
